import { useCallback } from 'react'
import { appcuesService } from '@/services/appcues'

export const useAppcues = () => {
  /**
   * Send an Appcues track event request
   */
  const track = useCallback(
    (eventName: string, properties: Record<string, unknown> = {}) => {
      appcuesService.track(eventName, properties)
    },
    []
  )

  return {
    track,
  }
}
